export * as InputsMessages from './inputs';
export * as ErrorsMessages from './errors';

export const generateId = () => (Math.random() / Math.random()).toString(32).substring(2);
